import React from 'react';
import { withRouter  } from 'react-router-dom';
import './App.scss';

import Header from './js/Header';
import Title from './js/Title';
import FilterList from './js/FilterList';
import Footer from './js/Footer';

// const API_ID = process.env.REACT_APP_API_ID 
// const API_TOKEN = process.env.REACT_APP_API_TOKEN

class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      error: null,
      rawData: null,
      isClicked: false,
      cleanedData: null,
      useMatchPath: ""
    }
    this.fetchScibble = this.fetchScibble.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount(){
    // console.log('comdidmount?')
    this.fetchScibble() 
   
  }
  toSeoUrl(url) { 
    // make the url lowercase         
    var encodedUrl = url.toString().toLowerCase(); 

    // replace & with and  
    // eslint-disable-next-line         
    encodedUrl = encodedUrl.split(/\&+/).join("-and-")

    // remove invalid characters 
    encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");       

    // remove duplicates 
    encodedUrl = encodedUrl.split(/-+/).join("-");

    // trim leading & trailing characters 
    encodedUrl = encodedUrl.trim('-'); 

    return encodedUrl; 
  }


  fetchScibble(){
    // fetch(`https://api.scribblelive.com/v1/stream/${API_ID}/posts?PageSize=100&Token=${API_TOKEN}`)
    fetch('https://interactives.stuff.co.nz/2020/08/election-2020-the-whole-truth/data/oldposts.json')
    .then(response =>response.json())
    .then(
      (data)=>{
        // console.log(data)
        var cleanedData = [],
            dataObject;
            // console.log('data.post:', data.posts)
        data.posts.forEach((postData, index) => {
          var postContent = postData.Content;

          var h1Start = postContent.indexOf('<h1>') + 4,
              h1End = postContent.indexOf('</h1>'),
              title = postContent.substring(h1Start, h1End);

          var h2Start = postContent.indexOf('<h2>') + 4,
              h2End = postContent.indexOf('</h2>'),
              subTitle = postContent.substring(h2Start, h2End);

          var postBodyStart = postContent.indexOf('</h2>') + 5,
              postBodyEnd = postContent.length,
              postBody = postContent.substring(postBodyStart, postBodyEnd);

          var label;
           if(!postData.PostMeta.Tags){
            label = "other"
          }else if(postData.PostMeta.Tags.length === 0){
            label = "other"
          }else{
            label = postData.PostMeta.Tags[0]
          };
        
          
          var postId = postData.Id;

          var autor = postData.Creator.Name;
          var autorPic = postData.Creator.Avatar;

          // var postDate = postData.CreationDate;
          // var dateStart = postDate.indexOf('2020-') + 5;
          // var dateEnd = postDate.indexOf('T');
          // var createdData = postDate.substring(dateStart,dateEnd)
          // console.log('date',createdData)

          var seoUrl = this.toSeoUrl(title);
          var creationDate = postData.CreationDate.substring(0,10);

          dataObject = {
            "title": title,
            "subTitle": subTitle,
            "seoUrl": seoUrl,
            "label": label,
            "postBody": postBody,
            "postId": postId,
            "autor" : autor,
            "autorPic" : autorPic,
            "creationDate": creationDate,
            "index": index
          };

          cleanedData.push(dataObject);
        });
        // console.log(cleanedData)
        this.setState({
          rawData: data.posts,
          cleanedData: cleanedData
        })

      },
      (error)=>{
        this.setState({
          error: error
        })
      }
    )
  }

  handleClick(e) {
    this.setState({
      isClicked: true
    })
  }
 
 
  render(){
    const { cleanedData } = this.state;
  return (
    <div className="App">
      <Header />
      <Title />
      <div className="bodycontainer">
      <FilterList
      handleClick={this.handleClick}
      cleanedData={cleanedData}
      
      />
      </div>
    
      <Footer />
    </div>
  );
}
}


export default withRouter(App);
